export const USER_TOKEN_REFRESH = 'USER_TOKEN_REFRESH';

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET';

export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET';

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL';
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET';

export const USER_UPDATE_PROFILE_INFO_REQUEST = 'USER_UPDATE_PROFILE_INFO_REQUEST';
export const USER_UPDATE_PROFILE_INFO_SUCCESS = 'USER_UPDATE_PROFILE_INFO_SUCCESS';
export const USER_UPDATE_PROFILE_INFO_FAIL = 'USER_UPDATE_PROFILE_INFO_FAIL';

export const USER_FOLLOW_REQUEST = 'USER_FOLLOW_REQUEST';
export const USER_FOLLOW_SUCCESS = 'USER_FOLLOW_SUCCESS';
export const USER_FOLLOW_FAIL = 'USER_FOLLOW_FAIL';
export const USER_FOLLOW_RESET = 'USER_FOLLOW_RESET';

export const USER_UNFOLLOW_REQUEST = 'USER_UNFOLLOW_REQUEST';
export const USER_UNFOLLOW_SUCCESS = 'USER_UNFOLLOW_SUCCESS';
export const USER_UNFOLLOW_FAIL = 'USER_UNFOLLOW_FAIL';
export const USER_UNFOLLOW_RESET = 'USER_UNFOLLOW_RESET';

export const USER_UPDATE_PROFILE_IMAGE_REQUEST = 'USER_UPDATE_PROFILE_IMAGE_REQUEST';
export const USER_UPDATE_PROFILE_IMAGE_SUCCESS = 'USER_UPDATE_PROFILE_IMAGE_SUCCESS';
export const USER_UPDATE_PROFILE_IMAGE_FAIL = 'USER_UPDATE_PROFILE_IMAGE_FAIL';
export const USER_UPDATE_PROFILE_IMAGE_RESET = 'USER_UPDATE_PROFILE_IMAGE_RESET';

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL = 'USER_LIST_FAIL';
export const USER_LIST_RESET = 'USER_LIST_RESET';

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAIL = 'USER_DELETE_FAIL';

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL';
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';

export const USER_SEND_MAIL_PROFILE_REQUEST = 'USER_SEND_MAIL_PROFILE_REQUEST';
export const USER_SEND_MAIL_PROFILE_SUCCESS = 'USER_SEND_MAIL_PROFILE_SUCCESS';
export const USER_SEND_MAIL_PROFILE_FAIL = 'USER_SEND_MAIL_PROFILE_FAIL';
export const USER_SEND_MAIL_PROFILE_RESET = 'USER_SEND_MAIL_PROFILE_RESET';

export const USER_VALIDATE_PROFILE_REQUEST = 'USER_VALIDATE_PROFILE_REQUEST';
export const USER_VALIDATE_PROFILE_SUCCESS = 'USER_VALIDATE_PROFILE_SUCCESS';
export const USER_VALIDATE_PROFILE_FAIL = 'USER_VALIDATE_PROFILE_FAIL';
export const USER_VALIDATE_PROFILE_RESET = 'USER_VALIDATE_PROFILE_RESET';

export const USER_SEND_MAIL_CHANGE_PASS_REQUEST = 'USER_SEND_MAIL_CHANGE_PASS_REQUEST';
export const USER_SEND_MAIL_CHANGE_PASS_SUCCESS = 'USER_SEND_MAIL_CHANGE_PASS_SUCCESS';
export const USER_SEND_MAIL_CHANGE_PASS_FAIL = 'USER_SEND_MAIL_CHANGE_PASS_FAIL';
export const USER_SEND_MAIL_CHANGE_PASS_RESET = 'USER_SEND_MAIL_CHANGE_PASS_RESET';

export const USER_CHANGE_PASS_PROFILE_REQUEST = 'USER_CHANGE_PASS_PROFILE_REQUEST';
export const USER_CHANGE_PASS_PROFILE_SUCCESS = 'USER_CHANGE_PASS_PROFILE_SUCCESS';
export const USER_CHANGE_PASS_PROFILE_FAIL = 'USER_CHANGE_PASS_PROFILE_FAIL';
export const USER_CHANGE_PASS_PROFILE_RESET = 'USER_CHANGE_PASS_PROFILE_RESET';
